import { ReactElement, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'

import List from '@/components/List'
import SectionTitle from '@/components/SectionTitle'

import { FAQPropType } from '@/propTypes'
import { ReactComponent as Group42 } from '@/svg/decorators/group-42.svg'
import { ReactComponent as Group379 } from '@/svg/decorators/group-379-secondary.svg'

import ExpandableContent from '@/features/landing/components/FAQ/ExpandableContent'

import Container from './style'

interface Props {
  items: FAQInterface[]
  style?: CSSProperties
  className?: string
  id?: string
}

function FAQ({ id, className, style, items }: Props): ReactElement {
  return (
    <Container id={id} className={className} style={style}>
      <div className="decorator-container">
        <Group42 id="group-42" />
        <Group379 id="group-379" />
      </div>
      <div className="container">
        <SectionTitle className="title">
          <span>คำถามที่พบบ่อย</span>
        </SectionTitle>
        <List>
          {items.map((faq: FAQInterface) => (
            <ExpandableContent key={faq.title} title={faq.title}>
              {faq.content}
            </ExpandableContent>
          ))}
        </List>
      </div>
    </Container>
  )
}

FAQ.propTypes = {
  items: PropTypes.arrayOf(FAQPropType).isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

FAQ.defaultProps = {
  className: '',
}

export default memo(FAQ)
